import RemoteServerCompleteFailureError from "lib/appserver/responseExceptions/RemoteServerCompleteFailureError";
import UnexpectedAPIResponseFormatError from "lib/appserver/responseExceptions/UnexpectedAPIResponseFormatError";
import UnknownDeviceError from "lib/appserver/responseExceptions/UnknownDeviceError";
import UnrecognisedResponseCodeError from "lib/appserver/responseExceptions/UnrecognisedResponseCodeError";

export function getErrorCode(error) {
  if (error.type !== undefined) {
    if (error.type === RemoteServerCompleteFailureError.type) {
      return "API_ERROR - APP_001";
    } else if (error.type === UnexpectedAPIResponseFormatError.type ||
      error.type === UnrecognisedResponseCodeError.type) {
      return "API_DATA_ERROR - APP_002";
    } else if (error.type === UnknownDeviceError.type) {
      return "UNKNOWN_DEVICE - APP_003";
    }
  }

  // If this is a React error then then name will be Error
  if (error.name === "Error") {
    return "INTERNAL_ERROR - APP_004";
  }

  return "UNKNOWN_ERROR - APP_005";
}



// WEBPACK FOOTER //
// ./src/lib/error-details/index.js